const Stock = () => import(/* webpackChunkName: "stock" */ '@/views/private/stock/Index.vue')
const Product = () => import(/* webpackChunkName: "stockproduct" */ '@/components/stock/Product.vue')
const Purchase = () => import(/* webpackChunkName: "stockpurchaseorder" */ '@/components/stock/PurchaseOrder.vue')
const Adjustment = () => import(/* webpackChunkName: "stockadjustment" */ '@/components/stock/Adjustment.vue')
const Opname = () => import(/* webpackChunkName: "stockopname" */ '@/components/stock/Opname.vue')
const CardStock = () => import(/* webpackChunkName: "cardstock" */ '@/components/stock/CardStock.vue')

const routes = [
  {
    path: "/stock",
    name: "stock",
    component: Stock,
    meta: {
      title: "Stock"
    },
    children: [
      {
        path: '/stock/product',
        name: 'stock product',
        component: Product,
        meta: {
          title: "Monitoring Stok"
        }
      },
      {
        path: '/stock/purchase',
        name: 'purchase',
        component: Purchase,
        meta: {
          title: "Pembelian"
        }
      },
      {
        path: '/stock/adjustment',
        name: 'stock adjustment',
        component: Adjustment,
        meta: {
          title: "Penyesuaian Stok"
        }
      },
      {
        path: '/stock/opname',
        name: 'stock opname',
        component: Opname,
        meta: {
          title: "Stok Opname"
        }
      },
      {
        path: '/stock/card-stock',
        name: 'stock card stock',
        component: CardStock,
        meta: {
          title: "Kartu Stok"
        }
      }
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})